import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core'

// Style configuration constants
const STYLE_CONFIG = {
    OVERLAY: {
        WIDTH: 15, // Extends 15px wide to cover adjacent pills
        HEIGHT: 25, // Height to match pill height
        Z_INDEX: 10, // Higher z-index to ensure it's above pills
    },
} as const

export const usePlainTextStyles = makeStyles((theme: Theme) => ({
    plainTextContainer: {
        minHeight: pxToRem(12),
        minWidth: pxToRem(1),
        paddingLeft: theme.spacing(0.1),
        cursor: 'text',
        display: 'inline-block',
        position: 'relative',
    },
    plainTextContainerWithContent: {
        minHeight: 'auto',
        minWidth: 'auto',
        cursor: 'text',
        opacity: 1,
    },
    plainTextContainerReadOnly: {
        cursor: 'default',
    },
    plainTextWrapperContainer: {
        position: 'relative',
        display: 'inline-block',
        width: 'max-content',
        minWidth: '1px', // Ensure consistent minimum size
    },
    plainTextContent: {
        display: 'inline-block',
        width: 'max-content',
        transition: 'width 0.1s ease, opacity 0.1s ease', // Smooth transition for specific properties
        '& > *': {
            width: 'auto',
            minWidth: '1px',
            maxWidth: 'none',
            display: 'inline-block',
            transition: 'width 0.1s ease, opacity 0.1s ease', // Smooth PlainText transitions for specific properties
        },
    },
    clickOverlay: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: pxToRem(STYLE_CONFIG.OVERLAY.WIDTH),
        height: pxToRem(STYLE_CONFIG.OVERLAY.HEIGHT),
        cursor: 'text',
        zIndex: STYLE_CONFIG.OVERLAY.Z_INDEX,
        pointerEvents: 'auto',
    },
}))
